import { Injectable, NgZone } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class InactivityService {
    private timeoutId: any;
    private readonly INACTIVITY_TIME = 90 * 60 * 1000; // 90 Minuets
    private readonly STORAGE_KEY = 'lastActivityTimestamp';
    private readonly STORAGE_UPDATE_THROTTLE = 1000; // Max 1x pro Sekunde in localStorage schreiben
    private lastStorageUpdate = 0;


    public onInactive = new Subject<void>();

    constructor(private ngZone: NgZone) {
        // Listen for activity in other tabs
        window.addEventListener('storage', (event) => {
            if (event.key === this.STORAGE_KEY && event.newValue) {
                this.resetTimer();
            }
        });
    }

    startWatching() {
        this.resetTimer();


        const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];

        events.forEach(event => {
            document.addEventListener(event, () => this.resetTimer(), true);
        });
    }

    private resetTimer() {
        clearTimeout(this.timeoutId);

        // Update activity timestamp for other tabs (throttled)
        const now = Date.now();

        if (now - this.lastStorageUpdate > this.STORAGE_UPDATE_THROTTLE) {
            localStorage.setItem(this.STORAGE_KEY, now.toString());
            this.lastStorageUpdate = now;
        }

        this.ngZone.runOutsideAngular(() => {
            this.timeoutId = setTimeout(() => {
                this.ngZone.run(() => {
                    this.onInactive.next();
                });
            }, this.INACTIVITY_TIME);
        });
    }

    stopWatching() {
        clearTimeout(this.timeoutId);
        localStorage.removeItem(this.STORAGE_KEY);
    }
}
